import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'zodi-home-shoe-banner',
  templateUrl: './home-shoe-banner.component.html',
  styleUrls: ['./home-shoe-banner.component.scss'],
})
export class HomeShoeBannerComponent implements OnInit, OnDestroy {
  private static readonly introFadeStartMs = 1200;
  private static readonly introFadeDurationMs = 720;
  private static readonly pairFadeDelayMs = 40;

  showIntroShoes = true;
  showPairShoe = false;
  isHidingIntroShoes = false;
  private fadeIntroShoesTimer: ReturnType<typeof setTimeout> | null = null;
  private hideIntroShoesTimer: ReturnType<typeof setTimeout> | null = null;
  private showPairShoeTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    this.fadeIntroShoesTimer = setTimeout(() => {
      this.isHidingIntroShoes = true;
    }, HomeShoeBannerComponent.introFadeStartMs);

    this.hideIntroShoesTimer = setTimeout(() => {
      this.showIntroShoes = false;
    }, HomeShoeBannerComponent.introFadeStartMs + HomeShoeBannerComponent.introFadeDurationMs);

    this.showPairShoeTimer = setTimeout(() => {
      this.showPairShoe = true;
    }, HomeShoeBannerComponent.introFadeStartMs + HomeShoeBannerComponent.introFadeDurationMs + HomeShoeBannerComponent.pairFadeDelayMs);
  }

  ngOnDestroy(): void {
    if (this.fadeIntroShoesTimer) {
      clearTimeout(this.fadeIntroShoesTimer);
    }

    if (this.hideIntroShoesTimer) {
      clearTimeout(this.hideIntroShoesTimer);
    }

    if (this.showPairShoeTimer) {
      clearTimeout(this.showPairShoeTimer);
    }
  }
}